<template>
    <v-btn class="upload-button" :disabled="uploading" @click="$refs.fileInput.click()">
        <template v-if="uploading">Uploading...</template>
        <template v-else>Upload</template>
        <v-icon>file_upload</v-icon>
        <input ref="fileInput" type="file" @change="setFile"
                accept="image/png, image/jpeg">
    </v-btn>
</template>

<script>
let elementId = 0

export default {
    props: ['imageUrl'],
    data() {
        return {
            url: '/upload/',
            uploading: false,
            imagePreviewUrl: null,
            inputId: `upload-widget-${++elementId}`,
        }
    },
    methods: {
        async setFile(ev) {
            const file = ev.target.files[0]
            this.imagePreviewUrl = window.URL.createObjectURL(file)
            this.uploading = true
            try {
                const form = new FormData()
                form.append('file', file, file.name)
                const response = await this.$store.dispatch('api/post', {
                    path: 'upload',
                    data: form,
                })
                this.$emit('upload', response.data)
                this.uploading = false
            } catch (e) {
                this.uploading = false
                throw e
            }
        },
    },
}
</script>

<style>
.upload-button input {
    position: absolute;
    left: -99999px;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadButton.vue